<div class="notification-wrapper">
  <!-- Notification button with unread badge -->
  <button mat-icon-button class="notification-button" (click)="toggleNotificationPanel()">
    <mat-icon>notifications</mat-icon>
    <span class="badge" *ngIf="unreadCount > 0">{{ unreadCount }}</span>
  </button>

  <div class="notification-panel" *ngIf="isNotificationPanelOpen">
    <div class="notification-header">
      <div class="header-content">
        <h2>Notifications</h2>
        <div class="header-actions">
          <button class="mark-all-read" *ngIf="hasUnreadNotifications()" (click)="markAllAsRead()">
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
              <path d="M12.96 7H9.028v-.691l2.579-3.72v-.054H9.098v-.867h3.785v.691l-2.567 3.72v.054h2.645V7z"/>
              <path d="M10.502 0H5.497c-.66 0-1.296.262-1.764.734L.5 4.168v6.666c0 .92.746 1.666 1.666 1.666h11.668c.92 0 1.666-.746 1.666-1.666V4.168L12.266.734C11.798.262 11.162 0 10.502 0ZM5.497 1h5.005c.396 0 .776.157 1.057.44l2.512 2.56H1.93l2.512-2.56A1.497 1.497 0 0 1 5.497 1Z"/>
            </svg>
            <span>Tout marquer comme lu</span>
          </button>
          <button mat-icon-button class="close-button" (click)="toggleNotificationPanel()">
            <mat-icon>close</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="notification-list">
      <!-- List of notifications -->
      <ul *ngIf="notifications.length > 0">
        <li *ngFor="let notification of notifications" [ngClass]="{'unread': !notification.isRead, 'read': notification.isRead}" (click)="onNotificationClick(notification)">
          <div class="notification-item" >
            <div class="notification-info">
              <!-- Image de profil à gauche -->
                <div class="container">
                  <div class="row">
                    <div class="col-2 col-md-2 col-sm-2 col-xs-2" >
                      <img [src]="notification.senderProfileImageUrl ? notification.senderProfileImageUrl : 'https://firebasestorage.googleapis.com/v0/b/lenali-21.appspot.com/o/profile2.png?alt=media&token=a24d9c4a-5daf-48c0-a265-88c4b0371f3c'" class="profile-image" alt="Profile"> 
                    </div>
                    <div class="col-8 col-md-8 col-sm-8 col-xs-8 pl-2 text" >
                      {{ notification.senderUserName }} a {{ notification.interactionType }} votre 
                      <ng-container [ngSwitch]="notification.postType">
                        <ng-container *ngSwitchCase="'video'">vidéo</ng-container>
                        <ng-container *ngSwitchCase="'image'">photo</ng-container>
                        <ng-container *ngSwitchCase="'text'">publication</ng-container>
                        <ng-container *ngSwitchDefault>publication</ng-container>
                      </ng-container>.
                    </div>
                    <div class="col-2 col-md-2 col-sm-2 col-xs-2" >
                      <!-- Image du post à droite -->
                      <div class="post-thumbnail-container">
                        <div class="post-thumbnail" [ngClass]="{
                          'video-thumbnail': notification.postType === 'video',
                          'text-thumbnail': notification.postType === 'text'
                        }">
                          <img [src]="notification.postImageUrl" class="post-image" alt="Post">
                          <div class="play-icon" *ngIf="notification.postType === 'video'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
                              <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                              <path d="M6.271 5.055a.5.5 0 0 1 .52.038l3.5 2.5a.5.5 0 0 1 0 .814l-3.5 2.5A.5.5 0 0 1 6 10.5v-5a.5.5 0 0 1 .271-.445z"/>
                            </svg>
                          </div>
                          <div class="text-icon" *ngIf="notification.postType === 'text'">
                            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-file-text" viewBox="0 0 16 16">
                              <path d="M5 4a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm-.5 2.5A.5.5 0 0 1 5 6h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5zM5 8a.5.5 0 0 0 0 1h6a.5.5 0 0 0 0-1H5zm0 2a.5.5 0 0 0 0 1h3a.5.5 0 0 0 0-1H5z"/>
                              <path d="M2 2a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V2zm10-1H4a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h8a1 1 0 0 0 1-1V2a1 1 0 0 0-1-1z"/>
                            </svg>
                          </div>
                        </div>
                        <div class="unread-indicator" *ngIf="!notification.isRead"></div>
                      </div>
                    </div>
                  </div>
                </div>
            
            </div>
            <small class="notification-date">{{ formatDate(notification.timestamp) }}</small>
            
          </div>
        </li>
      </ul>

      <!-- No notifications message -->
      <p *ngIf="notifications.length === 0">Aucune notification</p>
    </div>
  </div>
</div>
